import request from '@/utils/request'

export function login(name, password) {
	return request({
		url: '/admin/login',
		method: 'post',
		data: {
			name,
			password
		}
	})
}


// WEBPACK FOOTER //
// ./src/api/login.js